import React, { useState, Children } from 'react';
import { DiscIcon, ZapIcon, TruckIcon, FuelIcon, PackageIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const items = [{
  icon: DiscIcon,
  title: 'Flat',
  subtitle: 'Tire Change & Repair'
}, {
  icon: ZapIcon,
  title: 'Jumpstart',
  subtitle: 'Battery Service'
}, {
  icon: TruckIcon,
  title: 'Tow',
  subtitle: 'Emergency Towing'
}, {
  icon: FuelIcon,
  title: 'Refueling',
  subtitle: 'Fuel Delivery'
}, {
  icon: PackageIcon,
  title: 'Tire Delivery',
  subtitle: 'Mobile Install'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function UtilityRibbon() {
  const [selectedService, setSelectedService] = useState<string | null>(null);
  return <>
      <section className="w-full bg-secondary border-t border-white/10 relative z-20" data-id="element-351">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-5 divide-x divide-y md:divide-y-0 divide-white/20" data-id="element-352">
          {items.map((item, index) => <motion.button key={index} variants={itemVariants} onClick={() => setSelectedService(item.title)} className="group flex flex-col items-center justify-center py-6 md:h-[90px] px-4 hover:bg-white/5 transition-colors duration-300 w-full" data-id="element-353">
              <div className="flex items-center gap-3 mb-1" data-id="element-354">
                <item.icon className="w-5 h-5 text-white stroke-[1.5]" data-id="element-355" />
                <span className="font-bold text-white text-base md:text-lg whitespace-nowrap" data-id="element-356">
                  {item.title}
                </span>
              </div>
              <span className="text-white/60 text-sm font-medium" data-id="element-357">
                {item.subtitle}
              </span>
            </motion.button>)}
        </motion.div>
      </section>
      <AnimatePresence data-id="element-358">
        {selectedService && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-359">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setSelectedService(null)} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-360" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-md bg-white rounded-[10px] shadow-2xl overflow-hidden" data-id="element-361">
              <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-secondary text-white" data-id="element-362">
                <h3 className="text-xl font-bold" data-id="element-363">Request Service</h3>
                <button onClick={() => setSelectedService(null)} className="text-white/70 hover:text-white transition-colors" data-id="element-364">
                  <XIcon className="w-6 h-6" data-id="element-365" />
                </button>
              </div>
              <form className="p-6 space-y-4" onSubmit={e => {
            e.preventDefault();
            alert('Service requested!');
            setSelectedService(null);
          }} data-id="element-366">
                <div data-id="element-367">
                  <label className="block text-sm font-bold text-secondary mb-1" data-id="element-368">
                    Service Type
                  </label>
                  <input type="text" readOnly value={selectedService} className="w-full px-4 py-3 rounded-[10px] border border-gray-200 bg-gray-50 text-gray-900 font-medium focus:outline-none" data-id="element-369" />
                </div>
                <div data-id="element-370">
                  <label className="block text-sm font-bold text-secondary mb-1" data-id="element-371">
                    Full Name
                  </label>
                  <input type="text" required placeholder="John Doe" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-372" />
                </div>
                <div data-id="element-373">
                  <label className="block text-sm font-bold text-secondary mb-1" data-id="element-374">
                    Phone Number
                  </label>
                  <input type="tel" required placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-375" />
                </div>
                <div data-id="element-376">
                  <label className="block text-sm font-bold text-secondary mb-1" data-id="element-377">
                    Location (Zip or Address)
                  </label>
                  <input type="text" required placeholder="123 Main St or 90210" className="w-full px-4 py-3 rounded-[10px] border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" data-id="element-378" />
                </div>
                <button type="submit" className="w-full bg-primary hover:bg-red-800 text-white font-bold py-4 rounded-[10px] transition-colors mt-4 shadow-md" data-id="element-379">
                  Submit Request
                </button>
              </form>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}